var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.5h-2a2 2 0 110-4h2m0 4a1 1 0 001-1v-2a1 1 0 00-1-1m0 4v3a2 2 0 01-2 2H5a2 2 0 01-2-2V6m17 6.5v-3a2 2 0 00-2-2h-1.5M3 6a1.5 1.5 0 001.5 1.5H7M3 6a1.5 1.5 0 011.5-1.5h1M12 10V2m0 0l3 3m-3-3L9 5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgWalletOut;